import { Component, Input, OnInit } from '@angular/core';
import { FormService } from '../../../common/services/form.service';
import { ControlContainer, FormsModule, NgForm } from '@angular/forms';
import { HelperService } from 'src/sb-tools/typescript/services/helper.service';
import { BACKSPACE, COMMA, ENTER, SEMICOLON, SPACE } from 'src/sb-tools/typescript/constants/keycodes';
import { TypeaheadMatch, TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { Field } from 'src/sb-tools/typescript/models/field.model';
import { ClientField } from '../../../common/models/client-field.model';
import { BaseUserWithRole } from '@sb-tools/typescript/models/base-user-with-role.model';
import { TruncatePipe } from '@sb-tools/typescript/pipes/truncate.pipe';
import { InlineSVGComponent } from '../../../../Frontend-Inline-SVG-Module/inline-svg.component';
import { TranslateModule } from '@ngx-translate/core';
import { NgClass } from '@angular/common';
import { FocusDirective } from '@sb-tools/typescript/directives/focus.directive';
import { FormFieldLabelComponent } from '@form-field-module/common/components/form-field-label/form-field-label.component';

@Component({
    selector: 'sb-outbound-email-address',
    templateUrl: './outbound-email-address.component.html',
    styleUrls: ['./outbound-email-address.component.scss'],
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    imports: [
        TruncatePipe,
        InlineSVGComponent,
        TranslateModule,
        FormsModule,
        NgClass,
        TypeaheadModule,
        FocusDirective,
        FormFieldLabelComponent,
    ],
})
export class OutboundEmailAddressComponent implements OnInit {
    @Input() formField: Field | ClientField;

    allEmails: string[] = [];
    selectedEmail = '';
    selectedEmails: BaseUserWithRole[] = [];
    separatorKeys = [SPACE, ENTER, COMMA, SEMICOLON];

    constructor(
        public formService: FormService,
        private ngForm: NgForm,
    ) {}

    ngOnInit(): void {
        if (this.formField.defaultValue) {
            this.addEmail({
                item: this.formField.defaultValue,
            } as TypeaheadMatch);
        }
        this.allEmails = this.formField.possibleValues.map((item) => {
            return item.value;
        });
    }

    addEmail(event: TypeaheadMatch, callback?: () => void) {
        this.selectedEmails[0] = event.item;
        this.updateFormElementValue();

        if (callback) {
            callback();
        }

        this.selectedEmail = '';
    }

    checkAndAddNewEmail(callback?: () => void): void {
        if (HelperService.isEmailValid(this.selectedEmail)) {
            this.selectedEmail = this.selectedEmail.toLowerCase();

            this.addEmail(
                {
                    item: this.selectedEmail,
                } as TypeaheadMatch,
                callback,
            );
        }
    }

    keyDownHandler(event) {
        if (
            this.separatorKeys.find((item) => {
                return item === event.keyCode;
            })
        ) {
            const cleanSearchTextCallback = () => {
                event.target.value = '';
            };
            this.checkAndAddNewEmail(cleanSearchTextCallback);
            return false;
        }

        if (event && event.keyCode === BACKSPACE && !event.target.value) {
            this.selectedEmails = [];
        }
    }

    removeEmail(): void {
        this.selectedEmails = [];
        this.updateFormElementValue();
    }

    private updateFormElementValue(): void {
        if (this.selectedEmails.length) {
            this.formField.value = this.selectedEmails[0];
        } else {
            this.formField.value = null;
        }

        // trigger form values changes
        this.ngForm.form.updateValueAndValidity({ onlySelf: false, emitEvent: true });
    }
}
